import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialPopupComponent } from '@app/shared/modal-popup/social-popup/social-popup.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OrganizationService } from '../services/organizations/organization.service';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { ImagePopupComponent } from './image-popup/image-popup.component';
import { ProfilePopupComponent } from './profile-popup/profile-popup.component';
import { ImageCropperModule} from 'ngx-image-cropper';
import { AddressPopupComponent } from './address-popup/address-popup.component';
import { LeadService} from '@shared/services/leads/leads.service';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
  ],
  declarations: [
    SocialPopupComponent,
    ConfirmPopupComponent,
    ErrorPopupComponent,
    ImagePopupComponent,
    ProfilePopupComponent,
    AddressPopupComponent,
    ConfirmationPopupComponent,
  ],
  exports: [
    SocialPopupComponent,
    ConfirmPopupComponent,
    ErrorPopupComponent,
    ImagePopupComponent,
    ProfilePopupComponent,
    AddressPopupComponent,
    ConfirmationPopupComponent
  ],
  providers: [
    OrganizationService,
    LeadService
  ]
})

export class SocialPopupModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/social.popup.module.ts